
import { UserInfo } from "@/models/dossier/user-info";
import { AuthService, DossierService } from "@/services";
import { DashboardTab } from "@/utils/dashboard/dashboard-tab";
import { DashboardTabShare } from "@/utils/dashboard/dashboard-tab-share";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			allUsers: [] as UserInfo[],
			sharedUserIds: [] as number[],
		};
	},
	props: {
		tab: {
			type: Object as ()=>DashboardTab,
			required: true
		}
	},
	watch: {
		"tab.Shares": {
			immediate: true,
			handler(){
				this.sharedUserIds = this.tab.Shares.map(t=>t.UserID);
			}
		}
	},
	methods: {
		isUserChecked(userId:number):boolean {
			return this.sharedUserIds.indexOf(userId) != -1;
		},
		setUserChecked(userId:number, checked:boolean){
			if (checked){
				let i = this.sharedUserIds.indexOf(userId);
				if (i != -1) return;
				this.sharedUserIds.push(userId);
				return;
			}

			for (let i = this.sharedUserIds.length -1;i >= 0; i--){
				if (this.sharedUserIds[i] == userId) {
					this.sharedUserIds.splice(i,1);
				}
			}
		},
		close(){
			this.$emit("close");
		},
		confirm(){
			let deletedShares = this.tab.Shares.filter(s=>{
				return this.sharedUserIds.findIndex(u=>u==s.ID) == -1;
			});
			for (let deletedShare of deletedShares) {
				let i = this.tab.Shares.indexOf(deletedShare);
				if (i == -1) continue;
				this.tab.Shares.splice(i, 1);
			}
			for (let userId of this.sharedUserIds){
				let share = this.tab.Shares.find(s=>s.UserID == userId);
				if (share) continue;
				share = new DashboardTabShare();
				share.UserID = userId;
				share.TabID = this.tab.ID;
				this.tab.Shares.push(share);
			}
			this.close();
		}
	},
	async created(){
		let allUsers = await DossierService.getUsers();
		this.allUsers = allUsers.filter(a=>a.ID != AuthService.wfUser.ID);
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
